const _initialState = {
    accounts: [],
    productGroups: [],
    fetching: false,
    fetched: false,
    error: null,
};

const favorites = (state = _initialState, action) => {
    switch (action.type) {
    case "FETCH_USER_FAVORITES_REJECTED":
        return {...state, fetching: false, error: action.payload};

    case "FETCH_USER_FAVORITES_FULFILLED":
        return {
            ...state,
            fetching: false,
            fetched: true,
            accounts: action.payload.accounts,
            productGroups: action.payload.productGroups,
            opportunities: action.payload.opportunities,
        };

    case "POST_ACCOUNT_FAVORITE_FULFILLED":
        return {...state, userFavoritesAccounts: action.payload};

    case "POST_ACCOUNT_FAVORITE_REJECTED":
        return {...state, error: action.payload};

    case "ADD_FAVORITE_ACCOUNT":
        return {...state, accounts: [...state.accounts, action.account]};

    case "DELETE_FAVORITE_ACCOUNT":
        let accounts = state.accounts.slice().filter(
            (a) => (a.accountId !== action.account.accountId)
        );
        return {...state, accounts};

    case "POST_PRODUCT_GROUP_FAVORITE_FULFILLED":
        return {...state, userFavoritesProductGroups: action.payload};

    case "POST_PRODUCT_GROUP_FAVORITE_REJECTED":
        return {...state, error: action.payload};

    case "ADD_FAVORITE_PRODUCT_GROUP":
        return {
            ...state,
            productGroups: [...state.productGroups, action.productGroup]
        };

    case "DELETE_FAVORITE_PRODUCT_GROUP":
        let productGroups = state.productGroups.slice().filter(
            (p) => (p.productGroupId !== action.productGroup.productGroupId)
        );
        return {...state, productGroups};

    case "ADD_FAVORITE_OPPORTUNITY":
        return {
            ...state,
            opportunities: [...state.opportunities, action.opportunity]
        };

    case "DELETE_FAVORITE_OPPORTUNITY":
        let opportunities = state.opportunities.slice().filter(
            o => (o.opportunityId !== action.opportunity.opportunityId)
        );
        return {...state, opportunities};

    case "POST_OPPORTUNITY_FAVORITE_FULFILLED":
        return {...state, userFavoritesOpportunities: action.payload};

    case "POST_OPPORTUNITY_FAVORITE_REJECTED":
        return {...state, error: action.payload};

    default:
        return state;

    }
};

export default favorites;



// WEBPACK FOOTER //
// ./app/reducers/settings/favorites.js